import React, { Component } from "react";
import styles from "./styles.css";

export class CopyYourLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false
    };
  }

  copyToClipBoard = async () => {
    try {
      const { link } = this.props;
      await navigator.clipboard.writeText(link);
      if (link) {
        this.setState({ clicked: true });
      }
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const { link } = this.props;
    const handleCopyToClipBoard = this.copyToClipBoard;

    return (
      <div className={styles.container}>
        <b>Compartilhe seu link e ganhe prêmios</b>
        <div>
          <span onClick={handleCopyToClipBoard} className={styles.cursor}>
            {!this.state.clicked ? (
              'Clique para copiar seu link'
            ) : (
              'Link copiado com sucesso. Compartilhe!'
            )}
          </span>
          <button onClick={handleCopyToClipBoard}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"></path>
            </svg>
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/PrizeAccordion/CopyYourLink/index.jsx